module.exports = __webpack_public_path__ + "static/media/memento_feature_2.b3131f0b.png";